var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgF2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 49,
    viewBox: "0 0 57 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.3136 21.4075L43.9687 23.58L38.3438 12.8078L42.7329 10.6132C43.0626 10.4483 43.444 10.4195 43.7947 10.533C44.1455 10.6465 44.4377 10.8933 44.6083 11.2201L48.9313 19.4988C49.0177 19.6644 49.0703 19.8455 49.086 20.0316C49.1017 20.2177 49.0802 20.405 49.0227 20.5827C48.9652 20.7604 48.8729 20.9248 48.7512 21.0664C48.6294 21.2081 48.4807 21.324 48.3136 21.4075V21.4075Z",
    stroke: "white",
    strokeWidth: 1.60714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0324 23.3915L8.68751 21.2191C8.52048 21.1355 8.37175 21.0196 8.25001 20.878C8.12827 20.7364 8.03596 20.5719 7.97846 20.3942C7.92097 20.2165 7.89944 20.0292 7.91513 19.8431C7.93082 19.657 7.98343 19.4759 8.06987 19.3104L12.3928 11.0316C12.5635 10.7048 12.8557 10.4581 13.2064 10.3446C13.5572 10.231 13.9385 10.2598 14.2683 10.4247L18.6574 12.6193L13.0324 23.3915Z",
    stroke: "white",
    strokeWidth: 1.60714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9668 23.58L41.1543 26.8703L34.686 33.3385C34.5143 33.5102 34.3011 33.6346 34.0671 33.6994C33.833 33.7642 33.5862 33.7673 33.3506 33.7084L23.1629 31.1615C22.9718 31.1137 22.7929 31.0263 22.6377 30.905L13.0293 23.3916",
    stroke: "white",
    strokeWidth: 1.60714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.156 26.8701L33.4216 21.2451L31.1716 22.9326C30.1979 23.6629 29.0137 24.0576 27.7966 24.0576C26.5795 24.0576 25.3953 23.6629 24.4216 22.9326L23.4687 22.218C23.3076 22.0971 23.1742 21.943 23.0778 21.7661C22.9814 21.5892 22.9241 21.3936 22.9098 21.1927C22.8955 20.9917 22.9246 20.79 22.995 20.6012C23.0655 20.4125 23.1757 20.2411 23.3181 20.0986L30.1972 13.2195C30.3278 13.0889 30.4828 12.9853 30.6535 12.9147C30.8241 12.844 31.0069 12.8076 31.1916 12.8076H38.3435",
    stroke: "white",
    strokeWidth: 1.60714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7578 12.6191L27.7789 9.98919C28.1012 9.89524 28.4464 9.91966 28.7522 10.058L34.8287 12.8075",
    stroke: "white",
    strokeWidth: 1.60714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6855 37.4171L20.3876 36.0926C20.1726 36.0388 19.9734 35.935 19.8061 35.7897L15.8418 32.3438",
    stroke: "white",
    strokeWidth: 1.60714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -0.428572,
    y: -2.67857,
    width: 57.8571,
    height: 57.8571,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.21429
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgF2);
export default __webpack_public_path__ + "static/media/f2.0b2232c6591198c78857d01f24ae059b.svg";
export { ForwardRef as ReactComponent };